/* ══════════════════════════════════════════════════════════════
   PRISM OF TIME — comportements du thème
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ---- Filet de la barre de navigation ---- */
  var nav = document.querySelector('.nav');
  if (nav) {
    var majFilet = function () { nav.classList.toggle('scrolled', window.scrollY > 20); };
    majFilet();
    window.addEventListener('scroll', majFilet, { passive: true });
  }

  /* ---- Apparition au défilement ---- */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); observer.unobserve(en.target); }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal').forEach(function (el) { observer.observe(el); });

  /* ---- Compte à rebours (anneau = trotteuse) ---- */
  var CIRC = 2 * Math.PI * 18;
  function tick() {
    document.querySelectorAll('[data-arrivee]').forEach(function (t) {
      var cible = new Date(t.dataset.arrivee.replace(' ', 'T')).getTime();
      if (isNaN(cible)) return;
      var reste = cible - Date.now();
      var sweep = t.querySelector('.sweep');
      var units = t.querySelector('.units');

      if (reste <= 0) {
        if (units) units.innerHTML = '<span class="arrived">' + (t.dataset.labelArrivee || 'Disponible maintenant') + '</span>';
        if (sweep) sweep.style.strokeDashoffset = 0;
        return;
      }
      var s = Math.floor(reste / 1000);
      var set = function (u, v) {
        var el = t.querySelector('[data-u="' + u + '"]');
        if (el) el.textContent = String(v).padStart(2, '0');
      };
      set('j', Math.floor(s / 86400));
      set('h', Math.floor(s / 3600) % 24);
      set('m', Math.floor(s / 60) % 60);
      set('s', s % 60);
      if (sweep) sweep.style.strokeDashoffset = CIRC - (CIRC * ((s % 60) / 60));
    });
  }
  if (document.querySelector('[data-arrivee]')) { tick(); setInterval(tick, 1000); }

  /* ---- Galerie de la fiche produit ---- */
  var principale = document.querySelector('.gallery .frame.main img');
  if (principale) {
    document.querySelectorAll('.thumbs .frame').forEach(function (t) {
      t.addEventListener('click', function () {
        var grande = t.dataset.large;
        if (!grande) return;
        principale.src = grande;
        principale.srcset = '';
        document.querySelectorAll('.thumbs .frame').forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        t.setAttribute('aria-selected', 'true');
      });
    });
  }
})();
